import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-generic-table-dialog',
  templateUrl: './generic-table-dialog.component.html',
  styleUrls: ['./generic-table-dialog.component.scss']
})
export class GenericTableDialogComponent implements OnInit {

  @Input() title = '';
  @Input() dataSource: GenericTableDataSource = null;

  tableWidth = '100px';

  constructor() { }

  ngOnInit() {
    if (this.dataSource !== null) {
      this.tableWidth = (this.dataSource.titles.length * 120).toString() + 'px';
    }
  }

}

export interface GenericTableDataSource {
  titles: string[];
  rows: Row[];
}

export interface Row {
  row: string[];
}




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/generic-table-dialog/generic-table-dialog.component.ts